import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { API } from "aws-amplify";


const CLIENT_ID = '1021401243039-9bpn46dcisg3ihd52ei8e5rtv74om20p.apps.googleusercontent.com';
const API_KEY = 'e1AlyBZUbyu2vwVBmc71cVUJ';
// scopes {string} space delimited
const SCOPES = 'https://www.googleapis.com/auth/gmail.readonly ' +
  'https://www.googleapis.com/auth/gmail.send ' +
  'https://www.googleapis.com/auth/gmail.labels';
// const DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest"];


/* global gapi */ // prevent linting error on build
let script;
let GoogleAuth;
// let GoogleUser = null;


// https://developers.google.com/api-client-library/javascript/reference/referencedocs
// sample code source
// https://developers.google.com/identity/sign-in/web/reference#googleusergetbasicprofile
// https://developers.google.com/identity/sign-in/web/reference
// https://developers.google.com/identity/protocols/OAuth2
// https://developers.google.com/identity/protocols/OAuth2UserAgent
// https://developers.google.com/identity/protocols/googlescopes#gmailv1
// https://developers.google.com/gmail/api/v1/reference/users/getProfile


export default class AuthGmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: null,
      gapiReady: false,
    };
  }

  async componentDidMount() {
    try {
      await this.initGapi();
    } catch (error) {
      console.log(`componendDidMount ERROR`, error);
    }
  }

  async initGapi() {
    try {
      // this code sample loadClientWhenGapiReady from 
      //  https://gist.github.com/mikecrittenden/28fe4877ddabff65f589311fd5f8655c
      script = document.createElement("script");
      script.onload = () => {
        this.loadClientWhenGapiReady(script);
      };
      script.src = "https://apis.google.com/js/api.js";
      
      document.body.appendChild(script);
      
    } catch (error) {
      console.log(`initGapi ERROR`, error);
    }
  }

  loadClientWhenGapiReady = (script) => {
    gapi.load('client:auth2');
    if(script.getAttribute('gapi_processed')){
      this.setState({ gapiReady: true });
      this.initClient();
    }
    else{
      setTimeout(() => { this.loadClientWhenGapiReady(script) }, 100);
    }
  }

  initClient = async function() {
      // eslint-disable-next-line
      gapi.client.init({
        clientId: CLIENT_ID,
        apiKey: API_KEY,
        // discoveryDocs: DISCOVERY_DOCS,
        scope: SCOPES,
      })

      GoogleAuth = gapi.auth2.getAuthInstance();
      const GoogleUser1 = await GoogleAuth.currentUser.get();
      console.log('GoogleUser1', GoogleUser1);
  }

  sleepClient = async function(msec) {
    return new Promise(resolve => setTimeout(resolve, msec));
  }

  /**
   * @return {object} authResp, containing the authorization code
   * @return {Object} GoogleUser, info about the user and their account
   *     authResp Error Codes:
   *        (popup_closed_by_user, access_denied, immediate_failed)
   *    https://developers.google.com/api-client-library/javascript/reference/referencedocs#gapiauth2signinoptions
   */
  handleGrantAccess = async event => {
    const options = {
      // prompt: 'select_account',
      prompt: 'consent', // use this if prior auth call failed to get refresh_token
      scope: SCOPES,
    };
    try {
      const authResp = await GoogleAuth.grantOfflineAccess(options);
      const GoogleUser = await GoogleAuth.currentUser.get();

      const params = {
        AuthCode: authResp.code, // {string} - the code
        GoogleUser, // {object}
      };
      const wake = await this.sleepClient(500);
      console.log('wake', wake);

      await API.post("Gmail", "/authorize", {body: params});


    } catch (error) {
      console.log('handleGrantAccess ERROR', error);
    }
  }


  render() {
    return (
      <div className="SignupGmail">
        <h3>Setup Gmail</h3>
        <p>Here's how you connect your gmail... 
          <Button
            bsStyle="primary"
            bsSize="large"
            onClick={this.handleGrantAccess}
            >Activate Gmail
          </Button>
        </p>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/containers/settings/AuthGmail.js